// extracted by mini-css-extract-plugin
export default {"muted":"InquirySummary_muted__Vsx+h","company":"InquirySummary_company__5HuEG"};